module.exports = __webpack_public_path__ + "static/media/icon_arrow_down.66e5d6d6.svg";